import React from 'react'; 
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import {RootState, useAppDispatch, useAppSelector} from "../../../state/state.tsx";
import {closeModal, toggleLoading} from "../../../state/ModalSlice/ModalSlice.ts";
import {useBackend} from "../../../hooks/backend/useBackend.ts";
import {CircularProgress, IconButton} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { toast } from 'react-toastify';
import { selectEffectiveUID } from '../../../state/UserStatesV2/userSliceV2.ts';


export default function DeleteLiveSubscriptionModal() {

    const Dispatch = useAppDispatch();
    const ServiceProviderID = useAppSelector(selectEffectiveUID) 
    const open = useAppSelector((state: RootState) => state.ModalSlice.DeleteLiveSubscriptionModalOpen);
    const isLoading =  useAppSelector((state:RootState)=>state.ModalSlice.isLoading)


    function handleClose() {
        Dispatch(closeModal("DeleteLiveSubscriptionModalOpen"))
    }


    // OnSubmit Operations

    const {LiveSubscriptionId} = useAppSelector((state:RootState)=>state.ArbitrarySlice.ForDeleteLiveSubscriptionModal)

    const {remove} =useBackend(`/ServiceProviders/${ServiceProviderID}/LiveSubscriptions`)


    async function handleDeleteOperation(){
        const response =await remove(LiveSubscriptionId)
        if(response!=="error"){
            toast.success("Student is Deleted Successfully.")
        }
    }

       async function onSubmit(e: any) {
            e.preventDefault()
            Dispatch(toggleLoading(true))
            await handleDeleteOperation()
            Dispatch(toggleLoading(false))
            Dispatch(closeModal("DeleteLiveSubscriptionModalOpen"))
        }

    return (<React.Fragment>

        <Dialog
            sx={{
                padding: 0,
                '& .MuiPaper-root': {
                    borderRadius: '10px',
                },
            }}
            maxWidth="md"
            open={open}
            PaperProps={{
                component: 'div',
            }}
        >
            <DialogContent sx={{paddingX: "60px", paddingY: "40px"}} className={"bg-white"}>
                <div className={"header pb-[20px] min-w-[550px]"}>
                    <p className={"text-cf_heading font-[600] "}>Delete Student</p>
                    {/*<p className={"text-cf_small font-[400] "}>Add New Subscribers to {subscriptionName}</p>*/}
                </div>

                <div className={"absolute right-4 top-4"}><IconButton onClick={handleClose}>
                    <CloseIcon/>
                </IconButton></div>

                <div className={"pt-0"}>

                    <p>Are you sure you want to delete the student?</p>


                </div>

                <div className={"flex gap-2 pt-8"}>
                <button onClick={(e) => {
                        e.preventDefault();
                        handleClose()
                    }} disabled={isLoading}
                        className={`w-full bg-cc_bg-tertiary border border-solid border-gray-500 p-1.5 rounded-lg ${isLoading ? "cursor-not-allowed" : "cursor-pointer"}`}>Cancel
                    </button>
                    
                    <button
                        onClick={onSubmit} disabled={isLoading}
                        className={`w-full bg-cc_brand text-white p-1.5 rounded-lg border-gray-500 flex justify-center items-center ${isLoading ? "cursor-not-allowed" : "cursor-pointer"}`}>{isLoading &&
                            <CircularProgress sx={{ color: "white" }} size={20} />}
                        <p className={"ml-2"}>{isLoading ? "Loading" : "Delete Student"}</p>
                    </button>

                </div>
            </DialogContent>

        </Dialog>

    </React.Fragment>);
}